import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/path'

export const pathService = {
    calculatePath,
    saveMap,
    getItem
};

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//calculatePath
function calculatePath(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/calculatePath`, 'POST', { data: data });
}
//saveMap
function saveMap(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/saveMap`, 'POST', { data: data });
}
